import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Checkbox } from '@fs/zion-ui'
import { DmcGrid } from '../../common/DmcGrid'
import { QueuesContext } from '../QueuesContext'
import { deleteMessageById } from '../../../services/dmqueuesService'
import useNotifications from '../../../hooks/useNotifications'

export default function TableOperations({ queueState, queueActions, message }) {
  const { queuesData } = useContext(QueuesContext)
  const { t } = useTranslation()
  const { error } = useNotifications()
  const omitViewButtonForQueueTypeList = ['Historical Person Match', 'Same Sex Detected']
  const omitViewButtonForQueueNameList = ['CMISX_MISMATCH', 'DEITY']

  const executeButtonCallback = (tableButton) => {
    tableButton
      .buttonCallback({ message, queuesData })
      .then((response) => {
        deleteMessageById(response.messageId, response.resolution)
          .then(() => {
            queueActions.checkFinalPageAndReload(false)
          })
          .catch((err) => {
            error(t('queues.errorDeletingMessage', 'Error deleting message: {error}', { error: err.message }))
          })
      })
      .catch((err) => {
        error(t('queues.errorProcessingMessage', 'Error processing message: {error}', { error: err.message }))
      })
  }

  return (
    <DmcGrid columns={[1]} rowGap={5}>
      {queueState.viewButtonCallback !== null &&
        !omitViewButtonForQueueTypeList.some((type) => queueState.queueType?.includes(type)) &&
        !omitViewButtonForQueueNameList.some((name) => queueState.queueName?.includes(name)) && (
          <Button onClick={() => queueState.viewButtonCallback(message, queueActions.getMessageUrl(message))}>
            {t('action.view', 'View')}
          </Button>
        )}
      {queueState.tableButtons.map((tableButton) => {
        if (tableButton.dialogModalComponent != null) {
          return (
            <React.Fragment key={tableButton.buttonText}>
              {tableButton.dialogModalComponent(message, queueActions.loadPagination)}
            </React.Fragment>
          )
        }
        return (
          <Button key={tableButton.buttonText} onClick={() => executeButtonCallback(tableButton)}>
            {tableButton.buttonText}
          </Button>
        )
      })}
      {queueState.topButtons.length > 0 && (
        <Checkbox
          name="someName"
          checked={queueActions.isCheckboxSelected(message)}
          onChange={(event) => queueActions.addCheckboxSelection(message, event.target.checked)}
        />
      )}
    </DmcGrid>
  )
}
